var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 32 32","fill":"none"}},[_c('path',{attrs:{"d":"M18.7003 24L10.667 15.9667L18.7003 7.93335L20.1337 9.36668L13.5337 15.9667L20.1337 22.5667L18.7003 24Z","fill":_vm.color,"fill-opacity":"0.38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }